import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/services/auth.guard";
// import { CreateUserComponent } from "./create-user/create-user.component";

import { UserListComponent } from "./user-list/user-list.component";
// import { UserRolesComponent } from "./user-roles/user-role.component";
// import { ViewUserComponent } from "./view-user/view-user.component";
import {
  RESOURCE_ACTION,
  ROLE_RESOURCE_PERMISSIONS,
} from "src/constants/constants";
import { UserProfileComponent } from "./user-profile/user-profile.component";

const routes: Routes = [
  {
    path: "",
    // component: UserListComponent,
    data: {
      title: `User`,
    },
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: RESOURCE_ACTION.LIST,
      },
      {
        path: RESOURCE_ACTION.LIST,
        component: UserListComponent,
        data: {
          title: "",
          identifierName: [ROLE_RESOURCE_PERMISSIONS.USERS],
          permissions: [RESOURCE_ACTION.LIST],
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'user-profile/:userId',
        component: UserProfileComponent,
        data: {
          title: "",
          identifierName: [ROLE_RESOURCE_PERMISSIONS.USERS],
          permissions: [],
        },
        canActivate: [AuthGuard],
      }
      // {
      //   path: "detail/:id",
      //   component: ViewUserComponent,
      //   data: {
      //     title: "User-Detail",
      //   },
      //   canActivate: [AuthGuard],
      // },

      // {
      //   path: "roles/:id",
      //   component: UserRolesComponent,
      //   data: {
      //     title: "User-roles",
      //   },
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: "add",
      //   component: CreateUserComponent,
      //   data: {
      //     title: "User-add",
      //   },
      //   canActivate: [AuthGuard],
      // },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
